/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Action/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import ButtonMenuIcon from 'DesignSystem/ButtonMenuIcon/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Action({
  children,
  viewPath = "/App/Account/Content/Insights/Kpis/Definitions/Content/Menu/Action"
  
}) {
let actionTitleValueData = fromData.useDataValue({ viewPath,
context: 'action',
path: 'title',
})
let actionIdValueData = fromData.useDataValue({ viewPath,
context: 'action',
path: 'id',
})
let tabSelectedValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected',
})
let aggregateData = fromHelpers.isSelected(actionIdValueData, tabSelectedValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ButtonMenuIcon
  viewPath={`${viewPath}/ButtonMenuIcon`}
 paddingRight={16}
 data="action.title"
 text={actionTitleValueData}
 onClick={onClick}
 data="action.id"
 data="tab.selected"
 aggregate="helpers.js isSelected"
 isSelected={aggregateData}
/>
{children}
</React.Fragment>)
}